<template>
  <van-popup
    v-model="show"
    position="right"
    overlay-class="image-list-overlay"
    get-container="body"
    :safe-area-inset-bottom="true"
  >
    <div class="container">
      <div class="content">
        <div class="top-container">
          <div class="title">{{isEdit ? '上传图片' : '查看图片'}}</div>
          <div class="box-container">
            <div class="box img-container" v-for="(item, index) in obj.list" :key="item.etag">
              <div class="img">
                <img :src="item.url" class="box-img" @click="preview(index)" />
              </div>
              <van-icon
                v-if="isEdit"
                @click.stop="clear(index)"
                class="clear-icon"
                class-prefix="vxs-icon"
                size="14"
                name="qingchu"
                color="var(--c3)"
              />
            </div>
            <van-uploader
              ref="uploader"
              multiple
              result-type="dataUrl"
              max-count="9"
              :after-read="chooseImg"
              class="box"
              :max-size="maxSize * 1024 * 1024"
              @oversize="oversize"
              v-show="obj.list.length < max"
              v-if="isEdit"
            >
              <div class="box-add">
                <van-icon
                  name="system_add"
                  class-prefix="vxs-icon"
                  class="icon"
                  size="16"
                ></van-icon>
                <div>添加图片</div>
              </div>
            </van-uploader>
          </div>
        </div>
        <div class="desc">图片仅支持jpg、jpeg、png格式，最多上传{{ max }}张，每张不能超过10M</div>
      </div>
      <div class="btns" >
        <van-button type="default" class="btn" block @click="show = false" v-if="isEdit">取消</van-button>
        <van-button type="primary" class="btn" block @click="submit" v-if="isEdit">保存</van-button>
        <van-button type="default" class="btn" block @click="show = false" v-if="!isEdit">返回</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'image-list',
  props: {
    isEdit: {
      type: Boolean,
      default: true,
    },
    maxSize: {
      type: Number,
      default: 10,
    },
    max: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      show: false,
      obj: {
        list: [],
      },
    };
  },
  methods: {
    submit() {
      this.show = false;
      this._resolve && this._resolve(this.obj);
    },
    preview(index) {
      const urls = this.obj.list.map(item => item.url);
      vant.ImagePreview({
        startPosition: index,
        images: urls,
      });
    },
    oversize() {
      vant.Notify({
        type: 'warning',
        message: `视频文件大小不能超过 ${this.maxSize} MB，请压缩后重新上传`,
      });
    },
    open(obj) {
      this.obj = app.tool.clone(obj);
      this.show = true;
      return new Promise(resolve => (this._resolve = resolve));
    },
    async chooseImg(res) {
      vant.Toast.loading({
        message: '上传中...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true,
        duration: 0,
      });

      let files;
      if (Array.isArray(res)) {
        files = res.map(item => item.file);
      } else {
        files = [res.file];
      }

      let opts = Array.prototype.map.call(files, file => {
        return {
          platform: 'h5',
          options: {
            file: file,
          },
        };
      });
      let ret = await xgjzt.oss.uploadFiles(opts);
      this.obj.list = this.obj.list.concat(ret);
      vant.Toast.clear();
    },
    clear(index) {
      this.obj.list.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .content {
    overflow: auto;
    flex: 1 1 auto;
    background: var(--g1);
    .top-container {
      padding: 12px 16px;
      background: var(--white);
      .title {
        color: var(--g8);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        margin-bottom: 12px;
        width: 100%;
      }
    }
    .box-container {
      display: flex;
      flex-wrap: wrap;

      .box {
        width: 27vw;
        height: 80px;
        &:nth-child(3n + 1),
        &:nth-child(3n + 2) {
          margin-right: 3.2vw;
        }
        margin-bottom: 20px;

        &.img-container {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          .img {
            width: 100%;
            height: 100%;
            border-radius: var(--radius-base);
            overflow: hidden;
            .box-img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .clear-icon {
            padding: 4px;
            position: absolute;
            right: -12px;
            top: -12px;
          }
        }
        .box-add {
          border-radius: var(--radius-base);

          width: 27vw;
          height: 80px;
          background: var(--g2);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--c1);
          .icon {
            color: var(--c1);
          }
        }
      }
    }
    .desc {
      color: var(--g6);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      margin: 12px 16px;
    }
  }
  .btns {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    align-items: center;
    .btn {
      flex: 1 1 auto;
      border-radius: 8px;
      height: var(--cl-xs);
      &:first-child {
        margin-right: 12px;
      }
    }
  }
}
</style>